import {get, post, put, del} from "@/utils/request";

export default {
    getList: (param) => {
        return get('/question/list', param);
    },
    getData: (id) => {
        return get('/question/'+id);
    },
    addData: (data) => {
        return post('/question/add', data);
    },
    updateData: (data) => {
        return put('/question/update', data);
    },
    deleteData: (id) =>{
        return del('/question/'+id);
    },
    auditData:(data) => {
        return post('/question/audit',data)
    },
    searchQuestionListonList(param) {
        return get('/question/search', param);
    },
    increaseVisits:(id) => {
        return put('/question/increaseVisit/'+id)
    },
    getArticleUrl:(id) => {
    return get('/question/articleUrl/'+id);
    }
}